import { useAxios } from "./useAxios";
import { useUser } from "../contexts/UserContext";
import { useNotification } from "../contexts/NotificationProvider";

export const useLogin = () => {
  const { setToken } = useUser();
  const notify = useNotification();
  const { axiosInstance } = useAxios();
  const handleLogin = async (formData) => {
    // delete formData["remember"];
    try {
      const response = await axiosInstance.post("/accounts/login/", formData);
      setToken(response.data?.token);
      notify({
        type: "success",
        message: "Success",
        description: "User logged in successfully",
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return { handleLogin };
};
